import { render, staticRenderFns } from "./ValidateResult.vue?vue&type=template&id=27b29eec&lang=pug&"
import script from "./ValidateResult.vue?vue&type=script&lang=js&"
export * from "./ValidateResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports